import "./MainPanel.scss";
import Sidebar from "./PanelSidebar";
import Header from "./Header";
// import Footer from "./Footer";
import { useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { useState } from "react";
// import Logo from "../../Assets/img/nikooGl.png";

const Panel = ({ type }) => {
  const [open, setOpen] = useState(false);

  const location = useLocation();

  const title =
    location.state?.title !== undefined ? location.state.title : "پروفایل";
  return (
    <div className="panel-container">
      <Sidebar open={open} setOpen={setOpen} type={type} />
      <Header title={title} open={open} setOpen={setOpen} />
      <div className="panel-body">
        <Outlet />
        {/* <Profile/> */}
      </div>

      {/* <Footer /> */}
    </div>
  );
};

export default Panel;
